/**
 * Returns true if the URL points to the production Bridge API/compliance
 * portal (i.e. bridge.xyz without "sandbox" in the hostname).
 */
export const isProductionBridgeUrl = (url: string | null | undefined): boolean => {
  if (!url) return false
  try {
    const { hostname } = new URL(url)
    const isBridgeHostname =
      hostname === 'bridge.xyz' || hostname.endsWith('.bridge.xyz')
    const isSandboxHostname = hostname.includes('sandbox')
    return isBridgeHostname && !isSandboxHostname
  } catch {
    return false
  }
}

/**
 * Returns true when the frontend is running in a non-production environment.
 * Controlled explicitly via VITE_BRIDGE_SANDBOX=true in the env file.
 */
export const isSandboxEnvironment = (): boolean => {
  if (import.meta.env.DEV) return true
  return import.meta.env.VITE_BRIDGE_SANDBOX === 'true'
}

/**
 * Returns true if clicking this URL is safe in the current environment.
 * Production Bridge URLs are blocked on local/dev to prevent accidental
 * interactions with live Bridge accounts when prod data is mirrored locally.
 */
export const isBridgeUrlSafe = (url: string | null | undefined): boolean => {
  if (!url) return false
  if (isSandboxEnvironment() && isProductionBridgeUrl(url)) return false
  return true
}
